export const adminEventRegistrantsEmails = (params: { eventId: number }) => `event:${params.eventId}`;

export const adminRegistrantsEmail = (params: { eventId: number }) => `event:${params.eventId}`;
